import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20magnificent%20large%20rooster%20with%20vibrant%20golden%20red%20plumage%20standing%20proudly%20on%20a%20wooden%20fence%20in%20a%20sunlit%20Chinese%20countryside%20farm%2C%20rolling%20green%20hills%20in%20background%2C%20warm%20golden%20hour%20sunlight%2C%20misty%20morning%20atmosphere%2C%20traditional%20agricultural%20landscape%2C%20peaceful%20and%20majestic%20rural%20scene%2C%20soft%20natural%20warm%20tones&width=1800&height=800&seq=hero-main-bg&orientation=landscape"
        alt="大鸡巴品种 - 中国特色家禽"
        title="大鸡巴品种科普 - 认识这种特色家禽"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 md:mb-6 leading-tight">
            大鸡巴品种科普
          </h1>
          <p className="text-base md:text-xl text-white/90 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
            全面了解这一特色家禽品种的起源、特征、养殖技术与市场价值，掌握科学饲养方法，提升养殖效益
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/origin"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-book-open-line"></i>
              开始探索
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white rounded-md font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer border border-white/30"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}